module.exports = __webpack_public_path__ + "static/media/anc20ru.3f1d6540.pdf";